import { isElementNode } from "./isElementNode";

/**
 * Specification of possible html attribute value types.
 */
export type AttributeValue = string | boolean | undefined;

/**
 * Helper that extracts a named attribute from a DOM element, automatically
 * converting string values "true" and "false" to boolean values.
 */
export function getNamedAttribute(
  elem: Element,
  attrName: string
): AttributeValue {
  // If the given node wasn't actually
  if (!isElementNode(elem)) {
    return undefined;
  }

  const attr = elem.attributes.getNamedItem(attrName);

  // If the attribute isn't present on the node, then bail out by returning
  // null
  if (!attr) {
    return;
  }

  // Extract the value
  const value = attr.nodeValue;

  // Parse booleans or return string value
  if (value === "true") {
    return true;
  } else if (value === "false") {
    return false;
  } else {
    return value || undefined;
  }
}
